import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// api
import { getAwardWinningBookById, editAwardWinningBook, deleteAwardWinningBook } from 'api/company';
// components
import Title from 'components/backoffice/texts/title';
import AwardWinningBookForm from 'components/backoffice/forms/awardWinningBookForm';

const EditAwardWinningBook = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [award, setAward] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);

  const getAwardDetail = async () => {
    try {
      const { data, status } = await getAwardWinningBookById(id);
      if (status === 200) {
        setAward(data);
      } else {
        setAward({});
      }
    } catch (error) {
      console.error('Error fetching award:', error);
    }
  };

  useEffect(() => {
    getAwardDetail();
  }, []);

  useEffect(() => {
    if (award) {
      setTitle(t('edit', { title: award?.nombre }));
    }
    return () => {
      setTitle('');
    };
  }, [award, setTitle, t]);

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        nombre: values.nombre,
        year: values.year,
        producto_ids: values.products?.map((p) => p.value), 
      };
      const { status } = await editAwardWinningBook(id, payload);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/award-winning-books', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      toast.error(t('mensajeerror'), { theme: 'colored' });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteAwardWinningBook(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/award-winning-books', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.error('Error al eliminar:', error);
    }
  }, [id, navigate, t]);

  return (
    <div>
      <Title text={t('editAwardWinningBook')} />
      <AwardWinningBookForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        defaultValues={award}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        onDelete={handleDelete}
        id={id}
      />
    </div>
  );
};

export default EditAwardWinningBook;